import { Component, OnInit } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TitleType } from '../../../interface/title-type';
import { TitleTypeService } from '../../../service/title-type.service';
import { CommonModule } from '@angular/common';
import { MatCardSubtitle } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-operation-without-titletype',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    TranslateModule,

    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatCardSubtitle,
    MatSelect,
    MatOption,
    MatFormFieldModule,
    MatButton,
  ],
  templateUrl: './operation-without-titletype.component.html',
  styleUrls: ['./operation-without-titletype.component.css']
})
export class OperationWithoutTitletypeComponent implements OnInit {

  selectedTitle: string;
  titleTypes: TitleType[];

  constructor(
    private titleTypeService: TitleTypeService,
    private dialogRef: MatDialogRef<OperationWithoutTitletypeComponent>
  ) { }

  ngOnInit() {
    this.getExpenses()
  }

  private async getExpenses() {
    const types = await this.titleTypeService.getAll()
    this.titleTypes = types;
  }

  public async close(save: boolean) {
    if (save) {
      this.dialogRef.close(this.selectedTitle)
    } else {
      this.dialogRef.close()
    }
  }

}
